import "./HowItWorks.css";
import { motion, useReducedMotion } from "framer-motion";

const STEPS = [
  {
    number: "01",
    title: "Étterem Létrehozása",
    desc: "Állítsd be éttermedet percek alatt asztalokkal, felhasználókkal és saját arculattal.",
    icon: (
      <svg viewBox="0 0 48 48" fill="none">
        <path
          d="M8 20 12 8h24l4 12M8 20v18a2 2 0 0 0 2 2h4V26h20v14h4a2 2 0 0 0 2-2V20M8 20h32"
          stroke="currentColor"
          strokeWidth="2.4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path d="M18 26v6M30 26v6" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" />
      </svg>
    ),
  },
  {
    number: "02",
    title: "Menü Feltöltése",
    desc: "Adj hozzá kategóriákat, ételeket, képeket, árakat és leírásokat, hogy vendégeid modern digitális étlapból rendelhessenek.",
    icon: (
      <svg viewBox="0 0 48 48" fill="none">
        <rect x="10" y="6" width="28" height="36" rx="3" stroke="currentColor" strokeWidth="2.4" />
        <path
          d="M16 16h16M16 24h16M16 32h9"
          stroke="currentColor"
          strokeWidth="2.4"
          strokeLinecap="round"
        />
      </svg>
    ),
  },
  {
    number: "03",
    title: "QR kód kihelyezése",
    desc: "Töltsd le és helyezd ki a QR kódot az asztalokra — a vendégek azonnal elérik az étlapot, te pedig valós időben követed a rendeléseket.",
    icon: (
      <svg viewBox="0 0 48 48" fill="none">
        <rect x="7" y="7" width="12" height="12" rx="2" stroke="currentColor" strokeWidth="2.4" />
        <rect x="29" y="7" width="12" height="12" rx="2" stroke="currentColor" strokeWidth="2.4" />
        <rect x="7" y="29" width="12" height="12" rx="2" stroke="currentColor" strokeWidth="2.4" />
        <rect x="11.5" y="11.5" width="3" height="3" fill="currentColor" />
        <rect x="33.5" y="11.5" width="3" height="3" fill="currentColor" />
        <rect x="11.5" y="33.5" width="3" height="3" fill="currentColor" />
        <path
          d="M29 29h5v5h-5zM41 29v5M29 41h5M37 37h4v4h-4z"
          stroke="currentColor"
          strokeWidth="2.4"
          strokeLinejoin="round"
        />
      </svg>
    ),
  },
];

const cardVariants = {
  hidden: { opacity: 0, y: 28 },
  show: { opacity: 1, y: 0, transition: { duration: 0.55, ease: [0.16, 1, 0.3, 1] } },
};

function HowItWorks() {
  const prefersReducedMotion = useReducedMotion();

  return (
    <section className="landing-section landing-how-section" id="how">
      <h2 className="landing-section-title fade-up">Hogyan Működik?</h2>
      <p className="landing-how-subtitle fade-up">
        Három egyszerű lépés a regisztrációtól az első QR-kódos rendelésig.
      </p>

      <motion.div
        className="landing-steps"
        initial={prefersReducedMotion ? false : "hidden"}
        whileInView={prefersReducedMotion ? undefined : "show"}
        viewport={{ once: true, amount: 0.3 }}
        transition={{ staggerChildren: 0.18 }}
      >
        <div className="landing-steps-line" aria-hidden="true" />

        {STEPS.map((step) => (
          <motion.div
            className="landing-step-card"
            key={step.number}
            variants={prefersReducedMotion ? undefined : cardVariants}
          >
            <div className="landing-step-icon">{step.icon}</div>
            <div className="landing-step-number">{step.number}</div>
            <h3>{step.title}</h3>
            <p>{step.desc}</p>
          </motion.div>
        ))}
      </motion.div>
    </section>
  );
}

export default HowItWorks;
